import api from './ApiMiddleware';

const getAccountReport = (clientId) => {
  return api.get(`/api/x2/client/${clientId}/accounts/report`);
};

const AccountService = { getAccountReport };

export default AccountService;
